import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {ApplicationContactDTO} from '../../../../../../models/application/ApplicationContactDTO';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {UserAuthorisationService} from 'src/app/modules/common/services/user-authorisation.service';
import {ConfirmationDialogComponent} from 'src/app/modules/common/dialogs/confirmation-dialog/confirmation-dialog.component';
import {ApplicationContactDialogComponent} from 'src/app/modules/onboarding-admin-portal/components/dialogs/application-contact-dialog/application-contact-dialog.component';

@Component({
  selector: 'app-person-contacts',
  templateUrl: './person-contacts.component.html',
  styleUrls: ['./person-contacts.component.scss']
})
export class PersonContactsComponent implements OnChanges {
  hasPermissions = false;

  @Input() contacts: ApplicationContactDTO[];
  @Input() isApplicationLocked: boolean;
  @Input() applicationPersonId: number;

  @Output() contactsUpdated = new EventEmitter<{
    applicationPersonId: number;
    contactDetails: ApplicationContactDTO[];
  }>();

  constructor(
    private dialog: MatDialog,
    private userAuthorisationService: UserAuthorisationService
  ) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.isApplicationLocked) {
      this.isApplicationLocked = changes.isApplicationLocked.currentValue;
      this.setPermission();
    }
  }

  setPermission(): void {
    const hasRole = this.userAuthorisationService.hasOnBoardingQC() || this.userAuthorisationService.hasRoleEnterpriseManager();
    this.hasPermissions = hasRole && !this.isApplicationLocked;
  }

  getContactString(contact: ApplicationContactDTO): string {
    return `${contact.contactTypeCode ?? 'unknown'} - ${contact.contactValue ?? 'unknown'} - ${contact.isPreferred ? 'Preferred' : 'Not Preferred'}`;
  }

  OnAddContactDetails(): void {
    const dialogRef: MatDialogRef<ApplicationContactDialogComponent> = this.dialog.open(ApplicationContactDialogComponent, {
      width: '40vw',
      data: {}
    });

    dialogRef.afterClosed().subscribe((updatedContactDetails: ApplicationContactDTO) => {
      if (updatedContactDetails) {
        this.updateContacts(updatedContactDetails);
      }
    });
  }

  OnEditContactDetails(contactDetails: ApplicationContactDTO): void {
    const dialogRef: MatDialogRef<ApplicationContactDialogComponent> = this.dialog.open(ApplicationContactDialogComponent, {
      width: '40vw',
      data: {
        contactDetail: contactDetails
      }
    });

    dialogRef.afterClosed().subscribe((updatedContactDetails: ApplicationContactDTO): void => {
      if (updatedContactDetails) {
        this.updateContacts(updatedContactDetails);
      }
    });
  }

  OnDeleteContactDetails(contactDetailsToDelete: ApplicationContactDTO): void {
    const confirmationMessage = `Are you sure you want to delete ${contactDetailsToDelete.contactValue}?`;

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '40vw',
      data: confirmationMessage
    });

    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.deleteContact(contactDetailsToDelete);
      }
    });
  }

  private deleteContact(contactDetailsToDelete: ApplicationContactDTO): void {
    this.contacts = this.contacts.filter(
      (contact) => contact.applicationContactId !== contactDetailsToDelete.applicationContactId
    );
    this.emitContactDetails();
  }

  private updateContacts(updatedContactDetails: ApplicationContactDTO): void {
    const index = this.contacts.findIndex((contact: ApplicationContactDTO) => contact.applicationContactId === updatedContactDetails.applicationContactId);
    if (index !== -1) {
      this.contacts[index] = {...updatedContactDetails};
    }
    else {
      this.contacts.push(updatedContactDetails);
    }
    this.emitContactDetails();
  }

  private emitContactDetails(): void {
    this.contactsUpdated.emit({
      applicationPersonId: this.applicationPersonId,
      contactDetails: this.contacts
    });
  }

}